export default "__VITE_ASSET__Bxe3XsrB__"